import {
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  Divider,
  Grid,
  Tooltip,
  Typography,
} from "@mui/material";
import React from "react";
import AppButton from "../../components/app-button/AppButton";
import Iconify from "../../components/iconify/Iconify";
import { getOrderType } from "../../constants/enums";

function KOTCard({
  orderData,
  type,
  now,
  loadingIds,
  onCancelKOTClick,
  onFoodReadyClick,
}) {
  const kot = orderData?.kots[0];
  const kotCustomer = orderData.customer || {};
  const kotItems = kot.items || [];
  const kotDine = orderData.dine || {};
  const orderType = getOrderType(orderData.order_type_id);
  const kotId = kot.order_kot_uid;

  const createdAt = React.useMemo(() => {
    return new Date(kot.created_at.replace(" ", "T")).getTime();
  }, [kot.created_at]);

  const elapsedSeconds = Math.floor((now - createdAt) / 1000);

  const elapsed = React.useMemo(() => {
    const mins = Math.floor(elapsedSeconds / 60)
      .toString()
      .padStart(2, "0");
    const secs = (elapsedSeconds % 60).toString().padStart(2, "0");
    return `${mins}:${secs}`;
  }, [elapsedSeconds]);

  return (
    <Grid item xs={12} sm={6} md={4} key={orderData?.order_number}>
      <Card
        sx={{
          borderRadius: 3,
          boxShadow: 3,
        }}
      >
        <CardContent sx={{ flexGrow: 1, padding: 0 }}>
          <Box
            display="flex"
            justifyContent="space-between"
            gap="10px"
            className={`kot-card-header ${
              type === "menu_view" && "kot-card-header-10"
            }`}
            style={{
              backgroundColor:
                type !== "menu_view" ? orderType.bgColor : "#424242",
            }}
          >
            <Box className="kot-header-item">
              <Typography variant="caption2">KOT #{kot?.kot_number}</Typography>
              <Typography
                variant="body2"
                sx={{
                  fontSize: "11px",
                }}
              >
                Order #: {orderData?.order_number} ({orderType.label})
              </Typography>
            </Box>
            {/* {type !== "menu_view" && (
              <Box className="kot-header-item">
                <Typography variant="caption2">T3 (Rooftop)</Typography>
                <Typography variant="body2">Dine in</Typography>
              </Box>
            )} */}
            <Box
              className="kot-header-item"
              sx={{
                textAlign: "right",
              }}
            >
              <Typography variant="caption2">{elapsed}</Typography>
              <Typography
                variant="body2"
                sx={{
                  fontSize: "11px",
                }}
              >
                MM: SS
              </Typography>
            </Box>
          </Box>

          <Divider sx={{ bgcolor: "grey.200" }} />

          {type !== "menu_view" && (
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                gap: "10px",
              }}
              className="kot-cust-details"
            >
              {kotDine?.dine_area_name && orderType.label !== "Counter" && (
                <Typography
                  variant="body2"
                  color="text.secondary"
                  sx={{
                    fontSize: "12px",
                    paddingBottom: "4px",
                  }}
                >
                  {kotDine?.table?.table_name} ({kotDine?.dine_area_name})
                </Typography>
              )}
              {orderType.label === "Counter" && (
                <Typography
                  variant="body2"
                  color="text.secondary"
                  sx={{
                    fontSize: "12px",
                    paddingBottom: "4px",
                  }}
                >
                  Token #54321
                </Typography>
              )}
              {kotCustomer?.first_name && (
                <Typography
                  variant="body2"
                  color="text.secondary"
                  sx={{
                    fontSize: "12px",
                    paddingBottom: "4px",
                    marginLeft: "auto",
                  }}
                >
                  Cust Name: {kotCustomer?.first_name}
                </Typography>
              )}
            </Box>
          )}
          <Divider sx={{ bgcolor: "grey.200" }} />

          {/* Items header */}
          <Box className="kot-card-item-wrap">
            <Box
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              sx={{ mb: 1 }}
            >
              <Typography variant="caption" flex={1} color="grey">
                Items
              </Typography>
              <Typography
                variant="caption"
                sx={{ minWidth: 40, textAlign: "center" }}
                color="grey"
              >
                Qty
              </Typography>
            </Box>

            {/* Items list */}
            {kotItems.map((item, idx) => (
              <Box
                key={item?.variant_id || idx}
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                sx={{ mb: 0.5 }}
              >
                <Box display="flex" alignItems="center" gap="4px">
                  {orderData.quantity_delta !== 0 && (
                    <Box
                      sx={{
                        fontSize: 12,
                        fontWeight: "bold",
                      }}
                    >
                      [+]
                    </Box>
                  )}
                  <Tooltip title={item.variant_name} arrow>
                    <Typography
                      variant="body2"
                      sx={{
                        fontWeight: 500,
                        lineHeight: 1.3,
                        whiteSpace: "normal",
                        wordBreak: "break-word",
                        maxWidth: 180,
                      }}
                    >
                      {item.variant_name}
                    </Typography>
                  </Tooltip>
                </Box>
                <Typography
                  variant="body2"
                  sx={{ minWidth: 40, textAlign: "center" }}
                >
                  {item.quantity}
                </Typography>
              </Box>
            ))}

            {/* NOTES BLOCK */}
            {kot?.kot_comment && (
              <Box
                sx={{
                  mt: 2,
                  p: 1,
                  bgcolor: "#FFF3CD",
                  borderRadius: 1,
                  border: "1px dashed #FFB300",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: "5px",
                  }}
                >
                  <Iconify
                    icon="mdi:note-text-outline"
                    width={16}
                    color="#f57c00"
                  />
                  <Typography variant="caption" sx={{ fontStyle: "italic" }}>
                    {kot?.kot_comment}
                  </Typography>
                </Box>
              </Box>
            )}
          </Box>
        </CardContent>
        <CardActions
          sx={{
            p: 2,
            mt: "auto",
            display: "flex",
            justifyContent: "flex-end",
          }}
        >
          <Button
            size="small"
            variant="outlined"
            color="error"
            onClick={() => onCancelKOTClick({ ...kot, ...orderData })}
            disabled={!!loadingIds?.[kotId]}
          >
            Cancel
          </Button>

          <AppButton
            size="small"
            variant="contained"
            style={{
              backgroundColor: "gray",
            }}
            onClick={() => onFoodReadyClick({ ...kot, ...orderData })}
            startIcon={<Iconify icon="mdi:bell-check-outline" width={18} />}
            isLoading={!!loadingIds?.[kotId]}
          >
            Food is Ready
          </AppButton>
        </CardActions>
      </Card>
    </Grid>
  );
}
export default React.memo(KOTCard);
